// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__4pgkN","buttons":"SendReceipts_buttons__ZD6Q7","email":"SendReceipts_email__1fq5N","bookApptTitle":"SendReceipts_bookApptTitle__3o7kM"};